/*
  页面路由配置规则：

  path：页面访问路径
  name：路由名称 注意：该值需唯一
  component：页面组件路径 （其中 webpackChunkName: "layout" 不要删，需要通过它来做代码打包拆分，layout可以取路由名称name值，需保持唯一）
  redirect：路由重定向（按需使用）
  hidden：是否不在菜单栏中显示 true：隐藏 false：显示   注意：默认不需配置此字段，只有需要隐藏时配置（通常子页面需要配置该字段）
  meta：附加信息
    title：菜单标题 设置为语言管理中对应的key 规则为：应用名称_路由中定义的页面name值 如：示例应用_示例页面 -> base_demo
    icon：菜单图标  注意：只有一级页面才有该字段
    activeMenuTitle：进入子页面时左侧菜单栏中高亮的菜单名称（父级信息中的title值）注意：只有子页面才有该字段
    activeMenu：进入子页面时左侧菜单栏中高亮的菜单访问路径（父级信息中的path值）注意：只有子页面才有该字段

  注意：
      1、一级页面path配置：/ + 页面名称  如：/userManage
      2、二级页面path配置：一级页面path值 + / + 子页面名称   如：/userManage/userChild
      3、路由的 path 和 name 值走小驼峰形式
      4、应用名称取 vue.config.js 中的 publicPath 值，不需要 /，如：publicPath: '/base'，则应用名称为 base
*/

// 创建router-view
function createRouterView(name = Symbol('bgy')) {
  return {
    name,
    render: h => h('router-view')
  };
}

const dynamicRouters = [
  {
    path: '/',
    name: 'layout',
    component: () => import(/* webpackChunkName: "layout" */ '../views/layout/index.vue'),
    redirect: '/overview',
    hidden: true,
    children: [
      {
        path: '/overview',
        name: 'overview',
        component: () => import(/* webpackChunkName: "overview" */ '../views/overview/index.vue'),
        meta: {
          title: '概况总览',
          icon: 'icon-gaikuangzonglan'
        }
      },
      {
        path: '/equipmentCenter',
        name: 'equipmentCenter',
        component: createRouterView('equipmentCenter'),
        redirect: '/equipmentCenter/productManage',
        meta: {
          title: '设备中心',
          icon: 'icon-shebeizhongxin'
        },
        children: [
          {
            path: 'productManage',
            name: 'productManage',
            component: () =>
              import(/* webpackChunkName: "productManage" */ '../views/equipmentCenter/ProductManage.vue'),
            meta: {
              title: '产品管理'
            },
            children: [
              {
                path: 'productDetail',
                name: 'productDetail',
                component: () =>
                  import(/* webpackChunkName: "productDetail" */ '../views/equipmentCenter/ProductDetail.vue'),
                meta: {
                  title: '详情',
                  activeMenuName: 'productManage'
                }
              }
            ]
          },
          {
            path: 'deviceManage',
            name: 'deviceManage',
            component: () => import(/* webpackChunkName: "deviceManage" */ '../views/equipmentCenter/DeviceManage.vue'),
            meta: {
              title: '设备管理'
            },
            children: [
              {
                path: 'deviceDetail',
                name: 'deviceDetail',
                component: () =>
                  import(/* webpackChunkName: "deviceDetail" */ '../views/equipmentCenter/DeviceDetail.vue'),
                meta: {
                  title: '详情',
                  activeMenuName: 'deviceManage'
                }
              }
            ]
          },
          {
            path: 'productLineManage',
            name: 'productLineManage',
            component: () =>
              import(/* webpackChunkName: "productLineManage" */ '../views/equipmentCenter/ProductLineManage.vue'),
            meta: {
              title: '产线管理'
            },
            children: [
              {
                path: 'productLineDetail',
                name: 'productLineDetail',
                component: () =>
                  import(/* webpackChunkName: "productLineDetail" */ '../views/equipmentCenter/ProductLineDetail.vue'),
                meta: {
                  title: '详情',
                  activeMenuName: 'productLineManage'
                }
              }
            ]
          },
          {
            path: 'deviceGroup',
            name: 'deviceGroup',
            component: () => import(/* webpackChunkName: "deviceGroup" */ '../views/equipmentCenter/DeviceGroup.vue'),
            meta: {
              title: '设备分组'
            }
          }
        ]
      },
      {
        path: '/gatewayManage',
        name: 'gatewayManage',
        component: () => import(/* webpackChunkName: "gatewayManage" */ '../views/gatewayManage/index.vue'),
        meta: {
          title: '网关管理',
          icon: 'icon-wangguanguanli'
        },
        children: [
          {
            path: 'gatewayDetail',
            name: 'gatewayDetail',
            component: () => import(/* webpackChunkName: "gatewayDetail" */ '../views/gatewayManage/GatewayDetail.vue'),
            hidden: true,
            meta: {
              title: '详情',
              activeMenuName: 'gatewayManage'
            }
          }
        ]
      },
      {
        path: '/organizationManage',
        name: 'organizationManage',
        component: createRouterView('organizationManage'),
        redirect: '/organizationManage/companyManage',
        meta: {
          title: '组织机构',
          icon: 'icon-qiyeguanli'
        },
        children: [
          {
            path: 'companyManage',
            name: 'companyManage',
            component: () =>
              import(/* webpackChunkName: "companyManage" */ '../views/organizationManage/CompanyManage.vue'),
            meta: {
              title: '企业管理'
            }
          },
          {
            path: 'userManage',
            name: 'userManage',
            component: () => import(/* webpackChunkName: "userManage" */ '../views/organizationManage/UserManage.vue'),
            meta: {
              title: '用户管理'
            }
          },
          {
            path: 'roleManage',
            name: 'roleManage',
            component: () => import(/* webpackChunkName: "roleManage" */ '../views/organizationManage/RoleManage.vue'),
            meta: {
              title: '角色管理'
            },
            children: [
              {
                path: 'addOrModifyRole',
                name: 'addOrModifyRole',
                component: () =>
                  import(/* webpackChunkName: "addOrModifyRole" */ '../views/organizationManage/AddOrModifyRole.vue'),
                hidden: true,
                meta: {
                  title: '新增角色',
                  activeMenuName: 'roleManage'
                }
              }
            ]
          }
        ]
      },
      {
        path: '/customerManage',
        name: 'customerManage',
        component: () => import(/* webpackChunkName: "customerManage" */ '../views/customerManage/index.vue'),
        meta: {
          title: '客户管理',
          icon: 'icon-kehuguanli'
        },
        children: [
          {
            path: 'viewCustomer',
            name: 'viewCustomer',
            component: () => import(/* webpackChunkName: "viewCustomer" */ '../views/customerManage/ViewCustomer.vue'),
            hidden: true,
            meta: {
              title: '查看',
              activeMenuName: 'customerManage'
            }
          }
        ]
      },
      // {
      //   path: '/dataLargeScreen',
      //   name: 'dataLargeScreen',
      //   component: createRouterView('dataLargeScreen'),
      //   redirect: '/dataLargeScreen/my',
      //   meta: {
      //     title: '数据大屏',
      //     icon: 'icon-shujudaping'
      //   },
      //   children: [
      //     {
      //       path: 'my',
      //       name: 'my',
      //       component: () => import(/* webpackChunkName: "my" */ '../views/dataLargeScreen/My.vue'),
      //       meta: {
      //         title: '我的大屏'
      //       }
      //     },
      //     {
      //       path: 'template',
      //       name: 'template',
      //       component: () => import(/* webpackChunkName: "template" */ '../views/dataLargeScreen/Template.vue'),
      //       meta: {
      //         title: '模板中心'
      //       }
      //     },
      //     {
      //       path: 'dataSource',
      //       name: 'dataSource',
      //       component: () => import(/* webpackChunkName: "dataSource" */ '../views/dataLargeScreen/DataSource.vue'),
      //       meta: {
      //         title: '数据源'
      //       }
      //     }
      //   ]
      // },
      {
        path: '/spaceManage',
        name: 'spaceManage',
        component: () => import(/* webpackChunkName: "spaceOverview" */ '../views/spaceManage/SpaceOverview.vue'),
        meta: {
          title: '空间管理',
          icon: 'icon-kongjianguanli'
        }
      },
      {
        path: '/smsManage',
        name: 'smsManage',
        component: createRouterView('smsManage'),
        redirect: '/smsManage/smsOverview',
        meta: {
          title: '短信管理',
          icon: 'icon-duanxinguanli'
        },
        children: [
          {
            path: 'smsOverview',
            name: 'smsOverview',
            component: () => import(/* webpackChunkName: "smsOverview" */ '../views/smsManage/SmsOverview.vue'),
            meta: {
              title: '短信概况'
            }
          },
          {
            path: 'smsPackageManage',
            name: 'smsPackageManage',
            component: () => import(/* webpackChunkName: "smsPackageManage" */ '../views/smsManage/PackageManage.vue'),
            meta: {
              title: '套餐管理'
            }
          },
          {
            path: 'smsSalesRecords',
            name: 'smsSalesRecords',
            component: () => import(/* webpackChunkName: "smsSalesRecords" */ '../views/smsManage/SalesRecords.vue'),
            meta: {
              title: '销售记录'
            }
          }
        ]
      },
      {
        path: '/smsManageForCustomer',
        name: 'smsManageForCustomer',
        component: () =>
          import(/* webpackChunkName: "smsManageForCustomer" */ '../views/smsManageForCustomer/index.vue'),
        meta: {
          title: '短信管理',
          icon: 'icon-duanxinguanli'
        }
      },
      {
        path: '/iotCardManage',
        name: 'iotCardManage',
        component: createRouterView('iotCardManage'),
        redirect: '/iotCardManage/smsOverview',
        meta: {
          title: '物联卡管理',
          icon: 'icon-wuliankaguanli'
        },
        children: [
          {
            path: 'cardList',
            name: 'cardList',
            component: () => import(/* webpackChunkName: "cardList" */ '../views/iotCardManage/CardList.vue'),
            meta: {
              title: '卡片列表'
            }
          },
          {
            path: 'iotPackageManage',
            name: 'iotPackageManage',
            component: () =>
              import(/* webpackChunkName: "iotPackageManage" */ '../views/iotCardManage/IotPackageManage.vue'),
            meta: {
              title: '套餐管理'
            }
          },
          {
            path: 'iotSalesRecords',
            name: 'iotSalesRecords',
            component: () =>
              import(/* webpackChunkName: "iotSalesRecords" */ '../views/iotCardManage/IotSalesRecords.vue'),
            meta: {
              title: '销售记录'
            }
          },
          {
            path: 'renewalRecords',
            name: 'renewalRecords',
            component: () =>
              import(/* webpackChunkName: "renewalRecords" */ '../views/iotCardManage/RenewalRecords.vue'),
            meta: {
              title: '续费记录'
            }
          }
        ]
      },
      {
        path: '/iotCardManageForCustomer',
        name: 'iotCardManageForCustomer',
        component: () =>
          import(/* webpackChunkName: "iotCardManageForCustomer" */ '../views/iotCardManageForCustomer/index.vue'),
        meta: {
          title: '物联卡管理',
          icon: 'icon-wuliankaguanli'
        }
      },
      {
        path: '/workorderManage',
        name: 'workorderManage',
        component: () =>
          import(/* webpackChunkName: "workorderManage" */ '../views/workorderManage/index.vue'),
        meta: {
          title: '工单管理',
          icon: 'icon-gongdantongzhi'
        },
        children: [
          {
            path: 'outWorkorder',
            name: 'outWorkorder',
            component: () => import(/* webpackChunkName: "outWorkorder" */ '../views/workorderManage/platform/outWorkorder.vue'),
            hidden: true,
            meta: {
              title: '外部工单',
              activeMenuName: 'workorderManage'
            }
          }
        ]
      },
      {
        path: 'sendMessage',
        name: 'sendMessage',
        component: () => import(/* webpackChunkName: "sendMessage" */ '../views/messageCenter/SendMessage.vue'),
        meta: {
          title: '发送消息',
          icon: 'icon-xiaoxizhongxin'
        }

        // path: '/messageCenter',
        // name: 'messageCenter',
        // component: createRouterView('messageCenter'),
        // redirect: '/messageCenter/sendMessage',
        // meta: {
        //   title: '消息中心',
        //   icon: 'icon-xiaoxizhongxin'
        // },
        // children: [
        //   {
        //     path: 'sendMessage',
        //     name: 'sendMessage',
        //     component: () => import(/* webpackChunkName: "sendMessage" */ '../views/messageCenter/SendMessage.vue'),
        //     meta: {
        //       title: '发送消息'
        //     }
        //   }
        // ]
      },
      {
        path: '/notice',
        name: 'notice',
        hidden: true,
        component: () => import(/* webpackChunkName: "notice" */ '@/views/messageCenter/index.vue'),
        meta: {
          title: '消息通知'
        }
      },
      {
        path: '/messageCenterForCustomer',
        name: 'messageCenterForCustomer',
        hidden: true,
        component: () =>
          import(/* webpackChunkName: "messageCenterForCustomer" */ '@/views/messageCenterForCustomer/index.vue'),
        meta: {
          title: '消息通知',
          icon: 'icon-xiaoxizhongxin'
        }
      },
      {
        path: '/systemManage',
        name: 'systemManage',
        component: createRouterView('systemManage'),
        redirect: '/systemManage/systemSet',
        meta: {
          title: '系统管理',
          icon: 'icon-xitongguanli'
        },
        children: [
          {
            path: 'systemLogs',
            name: 'systemLogs',
            component: () => import(/* webpackChunkName: "systemLogs" */ '../views/systemManage/SystemLogs.vue'),
            meta: {
              title: '系统日志'
            }
          },
          {
            path: 'systemSet',
            name: 'systemSet',
            component: () => import(/* webpackChunkName: "systemSet" */ '../views/systemManage/SystemSet.vue'),
            meta: {
              title: '系统设置'
            }
          },
          {
            path: 'mobileSetting',
            name: 'mobileSetting',
            component: () => import(/* webpackChunkName: "mobileSetting" */ '../views/mobileSetting/index.vue'),
            meta: {
              title: '移动端设置'
            }
          }
        ]
      },
      {
        path: '/systemManageForCustomer',
        name: 'systemManageForCustomer',
        component: () =>
          import(/* webpackChunkName: "systemManageForCustomer" */ '../views/systemManageForCustomer/index.vue'),
        meta: {
          title: '系统日志',
          icon: 'icon-xitongguanli'
        }
      },
      // {
      //   path: '/mobileSetting',
      //   name: 'mobileSetting',
      //   component: () => import(/* webpackChunkName: "mobileSetting" */ '../views/mobileSetting/index.vue'),
      //   meta: {
      //     title: '移动端设置',
      //     icon: 'icon-duanxin'
      //   }
      // },
      {
        path: '/personalCenter',
        name: 'personalCenter',
        hidden: true,
        component: () => import(/* webpackChunkName: "personalCenter" */ '../views/personalCenter/index.vue'),
        meta: {
          title: '个人中心'
        }
      }
    ]
  }
];

export default dynamicRouters;
